export const MENU_TRANSLATE = {
    menu: {
        notFound: {
            text: "Sin elementos en el menú"
        },
        loading: {
            text: "Cargando menú"
        },
        breadcrumb: {
            actions: {
                menu: {
                    text: "Menú lateral"
                }
            }
        },
        toolbar: {
            title: "",
            adminTitle: "Administrador",
            actions: {
                logout: {
                    text: "Cerrar sesión"
                },
                myProfile: {
                    text: "Mi perfil"
                },
                configurations: {
                    text: "Configuración",
                    home: "Espacios",
                }
            }
        },

        group: {},
        items: {
            accounts: {
                name: "Cuentas",
            },
            admins: {
                name: "Administradores",
            },
            users: {
                name: "Usuarios"
            },
            categories: {
                name: "Categorías"
            },
            committees: {
                name: "Comités"
            },
            complaints: {
                name: "Denuncias"
            },
            languages: {
                name: "Idiomas"
            }
        }
    },
}
